// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDQjnT1yRuqnFBOSZKG5QCoT4LpdbPNUk8",
    authDomain: "myshop-7a60b.firebaseapp.com",
    databaseURL: "https://myshop-7a60b.firebaseio.com",
    projectId: "myshop-7a60b",
    storageBucket: "myshop-7a60b.appspot.com",
    messagingSenderId: "588401295978"
    //Old one
    //apiKey: "AIzaSyC5kr77VEU-FnklR5DBn3bPwmtmpEjYde4",
    //authDomain: "embryo-version-2.firebaseapp.com",
    //databaseURL: "https://embryo-version-2.firebaseio.com",
    //projectId: "embryo-version-2",
    //storageBucket: "embryo-version-2.appspot.com",
    //messagingSenderId: "73552048992"
  },
  //backEndUrl: "https://lontrayshop.azurewebsites.net/api", 
  backEndUrl: "https://localhost:44394/api",
  ratesapiURL:"https://api.ratesapi.io/api/latest?base=TRY&symbols=USD,EUR"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
